module.exports = __webpack_public_path__ + "img/section11.5e18b94f.png";